
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { SemFoto } from '../../../assets';
import { isColorLight } from '../../../utils/FunctionsGlobals';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import { whatsCardEquipeImobiliaria } from '../../../utils/whatsappImobiliaria';
import styles from './CardManager1.module.css';

// Foto do corretor pode dar 502 (arquivo ausente no storage). Sem fallback o card
// fica branco e texto de outro elemento vaza por cima. Troca pela imagem "sem foto".
function handleManagerPhotoError(event: React.SyntheticEvent<HTMLImageElement>) {
    const image = event.currentTarget;
    image.onerror = null; // evita loop se o próprio fallback falhar
    image.src = SemFoto.src;
}

const CardManager1: React.FC<{
    slide: any;
    site: any;
}> = ({ slide, site }) => {
    const legacyPhoto = `https://fotos.sobressai.com.br/fotos/corretores/${site?.id}/${slide?.id}/${slide?.id}_g.jpg?v=${slide?.contador_atualizacao || 0}`;
    const storedPhoto = typeof slide?.url_foto === 'string' && slide.url_foto.trim() ? slide.url_foto.trim() : '';
    const GetPhoto = storedPhoto || legacyPhoto;
    const cor_texto = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 
    const cor_texto_botoes = isColorLight(site?.cor12) ? site?.cor11 : site?.cor13; 

    return (
        <div className={styles.container}>
            <div className={styles.mainContent}>
                <div className={styles.imageAndMobileStats}>
                    <img
                        alt={`Ver imóveis agenciados por ${slide?.nome}`}
                        loading="lazy"
                        decoding="async"
                        className={styles.profileImage}
                        src={GetPhoto}
                        onError={handleManagerPhotoError}
                        title={`Ver imóveis agenciados por ${slide?.nome}`}
                        onClick={() => {
                            slide?.link_proprio 
                                ? window.open(slide?.link_proprio, '_blank') 
                                : window.open(`/imoveis/venda/-/-/-/-?agenciador=${slide?.id}`)
                        }}
                    />
                </div>
                
                <div className={styles.infoSection}>
                    <h3 className={styles.name} style={{color: cor_texto}}>{slide?.nome}</h3>
                    
                    {site?.id != '2091' && (
                        <p className={styles.role} style={{color: cor_texto}}>
                            {slide?.funcao?.nome || 'Corretor de Imóveis'}
                        </p>
                    )}
                    
                    {/* <p className={styles.description}>
                        {slide?.descricao}
                    </p> */}
                    
                    {slide?.telefone && site?.id != 1803 && (
                        <a
                            href={
                                whatsCardEquipeImobiliaria(site?.id == '1937' 
                                    ? `https://api.whatsapp.com/send?phone=${slide?.telefone?.replace(/\D/g, '')}` 
                                    : `https://api.whatsapp.com/send?phone=55${slide?.telefone?.replace(/\D/g, '')}&text=Olá ${slide?.nome}!%0A%0AAcabei de acessar o site da ${site?.Dados?.empresa} e gostaria de saber mais sobre seus serviços.%0A%0AFico no aguardo do seu retorno!`, site, slide, 'E')
                            }
                            onClick={async (e) => {
                                e.preventDefault();
                                trackLead(site, null);
                                setTimeout(() => {
                                    window.open(
                                        whatsCardEquipeImobiliaria(site?.id == '1937' 
                                            ? `https://api.whatsapp.com/send?phone=${slide?.telefone?.replace(/\D/g, '')}` 
                                            : `https://api.whatsapp.com/send?phone=55${slide?.telefone?.replace(/\D/g, '')}&text=Olá ${slide?.nome}!%0A%0AAcabei de acessar o site da ${site?.Dados?.empresa} e gostaria de saber mais sobre seus serviços.%0A%0AFico no aguardo do seu retorno!`, site, slide, 'E'),
                                        "_blank"
                                    );
                                }, 300);
                            }}
                            className={styles.mobileButton}
                            style={{color: cor_texto_botoes}}
                        >
                            Conhecer {slide?.nome}
                        </a>
                    )}
                </div>
                
                <div className={styles.desktopStats}>
                    {slide?.telefone && site?.id != 1803 && (
                        <a
                            href={
                                whatsCardEquipeImobiliaria(site?.id == '1937' 
                                    ? `https://api.whatsapp.com/send?phone=${slide?.telefone?.replace(/\D/g, '')}` 
                                    : `https://api.whatsapp.com/send?phone=55${slide?.telefone?.replace(/\D/g, '')}&text=Olá ${slide?.nome}!%0A%0AAcabei de acessar o site da ${site?.Dados?.empresa} e gostaria de saber mais sobre seus serviços.%0A%0AFico no aguardo do seu retorno!`, site, slide, 'E')
                            }
                            onClick={async (e) => {
                                e.preventDefault();
                                trackLead(site, null);
                                setTimeout(() => {
                                    window.open(
                                        whatsCardEquipeImobiliaria(site?.id == '1937' 
                                            ? `https://api.whatsapp.com/send?phone=${slide?.telefone?.replace(/\D/g, '')}` 
                                            : `https://api.whatsapp.com/send?phone=55${slide?.telefone?.replace(/\D/g, '')}&text=Olá ${slide?.nome}!%0A%0AAcabei de acessar o site da ${site?.Dados?.empresa} e gostaria de saber mais sobre seus serviços.%0A%0AFico no aguardo do seu retorno!`, site, slide, 'E'),
                                        "_blank"
                                    );
                                }, 300);
                            }}
                            className={styles.desktopButton}
                        >
                            Conhecer {slide?.nome}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardManager1;
